import { render, staticRenderFns } from "./TableExtended.vue?vue&type=template&id=14df51ec&"
import script from "./TableExtended.vue?vue&type=script&lang=js&"
export * from "./TableExtended.vue?vue&type=script&lang=js&"
import style0 from "./TableExtended.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports